import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { pca } from './authConfig';
import 'antd/dist/reset.css'; 


const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <App msalInstance={pca} />
  </React.StrictMode>
);
